/**
 * Navn for ny snarvei: eksplisitt navn i skjema vinner; ellers brukes visningsnavn fra valgt mål.
 */
export function resolveShortcutMenuItemName (formName: string, targetName: string): string {
  const trimmed = String(formName || '').trim();
  if (trimmed) {
    return trimmed;
  }
  return String(targetName || '').trim();
}
